<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-tooltip top slot="activator">
            <v-btn icon slot="activator">
                <v-icon>info</v-icon>
            </v-btn>
            <span>Info</span>
        </v-tooltip>
        <v-card>
            <v-card-title 
            class="headline grey lighten-2"
            primary-title
            >
                <span class="headline">{{title}}</span>
            </v-card-title>
            <v-card-text>
                <p v-for="(item, i) in content" :key="i">
                    {{item}}
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialog = false">{{close}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    content: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    close: {
      type: String,
      required: false,
      default: 'Ok'
    }
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Misc/InfoDialog.vue